const getters = {
  layouts: ({ layouts }) => layouts,

  layoutsArray: ({ layouts }) => Object.keys(layouts).map(key => layouts[key]),

  layoutsSimple: ({ layouts }) => Object.keys(layouts).map(key => ({
    label: layouts[key].name,
    value: layouts[key].id
  })),

  byKey: state => key => state.layouts[key],

  active: ({ active }) => active,

  newLayout: ({ newLayout }) => newLayout,

  currentPage: ({ currentPage }) => currentPage,

  totalPageCount: ({ totalPageCount }) => totalPageCount,

  perPage: ({ perPage }) => perPage,

  revisions: ({ revisions }) => revisions,

  shortRevisionList: ({ shortRevisionList }) => shortRevisionList,

  activeRevisionId: ({ activeRevisionId }) => activeRevisionId
}

export default getters
